export enum TicketsActionType {
  FETCH_TICKETS = 'FETCH_TICKETS',
  CREATE_TICKET = 'CREATE_TICKET',
  FETCH_UPDATE_TICKET = 'FETCH_UPDATE_TICKET',
  FETCH_CATEGORIES = 'FETCH_CATEGORIES',
  FETCH_SUBCATEGORIES = 'FETCH_SUBCATEGORIES',
  FETCH_INFO_FOR_TICKET = 'FETCH_INFO_FOR_TICKET',
  FETCH_ATTACHMENTS_FOR_TICKET = 'FETCH_ATTACHMENTS_FOR_TICKET',
  READ_COMMENT = 'READ_COMMENT'
}
